<template>
    <div class="coupon" :style="'padding: 0 ' + item.prConfig.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
        <div class="couponBox" :style="'background-color: ' + item.bgColor.color[0].item + ';'" :class="{'border-radius' : item.bgStyle.type == 1}">
            <div class="coupon-item" v-for="(couponItem,index) in 3" :key="index" :style="'background-color: ' + item.themeColor.color[0].item + ';'" :class="{'active' : index == 1}">
                <div class="item-left">
                    <div class="cpupon-price">
                        <span>￥</span>
                        <span class="number">10</span>
                    </div>
                    <span>满100元可用</span>
                </div>
                <div class="item-right">
                    <span>立</span>
                    <span>即</span>
                    <span>领</span>
                    <span>取</span>
                    <div class="top"></div>
                    <div class="bottom"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>

<style scoped lang="scss">
.couponBox{
    width: 100%;
    padding: 12px 0 12px 12px;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .coupon-item{
        flex-shrink: 0;
        width: 135px;
        height: 76px;
        margin-right: 12px;
        border-radius: 5px;
        overflow: hidden;
        display: flex;

        .item-left{
            width: 104px;
            height: 100%;
            font-size: 12px;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .cpupon-price{
                font-weight: 800;
            }

            .number{
                font-size: 20px;
            }

        }

        .item-right{
            position: relative;
            width: 30px;
            height: 100%;
            line-height: 16px;
            font-size: 12px;
            color: #fff;
            border-left: 1px dashed #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .top{
                position: absolute;
                left: -5px;
                top: -5px;
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 50%;
            }

            .bottom{
                position: absolute;
                left: -5px;
                bottom: -5px;
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 50%;
            }
        }
    }

    .active{
        background-color: #d8d8d8 !important;
    }
}

.border-radius{
    border-radius: 6px;
}
</style>